export const errorHandlerStyled = `
  .error_container__root {
    width: 100%;
    height: 60vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    gap: 1em;
  }
  .error-handler__content-error {
    width: 100%;
    gap: 2em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: "Poppins";
  }
  .error-handler__content-error h1, .error-handler__error-title {
    font-family: "Montserrat";
  }
  .error_container__code p {
    font-family: "Montserrat";
    color: #002eff;
    font-size: 4rem;
    font-weight: 600;
  }
  .error-handler__content-botton-back button {
    width: 12rem;
    height: 3rem;
    padding: 0 1em;
    border-radius: 1.5rem;
    font-weight: 500;
    font-size: 1rem;
    color: #FFFFFF;
    background: #002eff;
  }
  .error-handler__content-botton-back button:hover {
    background: #002eff;
  }
`